import { IReactionDisposer } from 'mobx';

import { ILocalStore } from '@/types/store';

export abstract class LocalStore implements ILocalStore {
  private reactionDisposers: IReactionDisposer[] = [];
  private isDestroyed = false;

  addReaction(reaction: IReactionDisposer): void {
    // Реакцию добавили после await, а стор уже уничтожен — иначе она жила бы вечно
    if (this.isDestroyed) {
      reaction();

      return;
    }

    this.reactionDisposers.push(reaction);
  }

  addReactions(reactions: IReactionDisposer[]): void {
    reactions.forEach((r) => this.addReaction(r));
  }

  destroyReactions(): void {
    this.reactionDisposers.forEach((disposer) => disposer());
  }

  destroy(): void {
    this.isDestroyed = true;
    this.destroyReactions();
  }
}
